<div [formGroup]="group" class="mt-3 grid grid-cols-2 gap-4">
	<app-input
		label="Email"
		name="email"
		type="email"
		formControlName="email"
		[labelIcon]="globalIcon"
		[labelToolTip]="labelTooltip"
	></app-input>
	<app-input
		label="Email (additional)"
		name="email2"
		type="email"
		formControlName="email2"
		[labelIcon]="globalIcon"
		[labelToolTip]="labelTooltip"
	></app-input>
	<app-input
		label="Phone number"
		name="phone"
		type="text"
		formControlName="phone"
		[labelIcon]="globalIcon"
		[labelToolTip]="labelTooltip"
	></app-input>
	<app-input
		label="Phone number (additional)"
		name="phone2"
		formControlName="phone2"
		type="text"
		[labelIcon]="globalIcon"
		[labelToolTip]="labelTooltip"
	></app-input>
	<app-input
		class="cols-span-2"
		label="Fax"
		name="fax"
		formControlName="fax"
		type="text"
		[labelIcon]="globalIcon"
		[labelToolTip]="labelTooltip"
	></app-input>
</div>
